<template lang="pug">
    div#app
        router-view
        cookie-notice
</template>

<script>
import CookieNotice from '@/components/cookie-notice'

export default {
    name: 'app',
    components: {
        CookieNotice
    }
}
</script>

<style lang="stylus"></style>
